<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="searchForm" :inline="true" size="mini" label-width="80px">
          <el-form-item label="产品编码">
            <el-input v-model.trim="searchForm.productCodeQuery" placeholder="产品编码"></el-input>
          </el-form-item>
          <el-form-item label="产品名称">
            <el-input v-model.trim="searchForm.productNameQuery" placeholder="产品名称"></el-input>
          </el-form-item>
          <el-form-item label="产品型号">
            <el-input v-model.trim="searchForm.modelNameQuery" placeholder="型号"></el-input>
          </el-form-item>
          <el-form-item label="品类">
            <el-select v-model="searchForm.categoryQuery" filterable placeholder="全部">
              <el-option label="全部" value="" />
              <el-option v-for="item in varietyList" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上市时间">
            <form-date-range :form="searchForm" startKey="upDateStart" endKey="upDateEnd" :usingTime="false" valueFormat="yyyyMMdd"></form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button
          type="primary"
          @click="exportExcel"
          size="mini"
          v-loading.fullscreen.lock="loadingExport"
          element-loading-text="数据导出中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          导出
        </el-button>
        <el-button type="primary" size="mini" @click="tableVisible = true">表格设置</el-button>
      </template>
      <el-table
        ref="table"
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        :data="tableData.records"
        :height="maxTableHeight"
        style="width: 100%"
        border
        v-if="tableReload"
      >
        <el-table-column
          v-for="(item, index) in columnData"
          :key="item.columnName + index"
          :align="`${item.fieldType == 'string' ? 'left' : 'right'}`"
          show-overflow-tooltip
          :label="item.displayName"
          :fixed="item.freezeType"
          :prop="item.columnName"
          :min-width="item.displayWidth"
        >
          <template #header v-if="item.fieldType == 'string' && item.displayName != '图片'">
            <q-table-header-filter
              :prop="item.columnName"
              :label="item.displayName"
              :useSort="true"
              :filterType="item.fieldType"
              table="retirementAnalysis"
              :filterOptions="headerFilterOptions[item.columnName]"
              :getFilterOptions="cheoxList"
              :searchReset="searchReset"
              @confirmFilter="confirmFilter"
              @cheoxList="cheoxList"
            />
          </template>
          <template #header v-else-if="item.fieldType !== 'string' && item.displayName != '图片'">
            <q-table-header-filter
              :prop="item.columnName"
              :label="item.displayName"
              :useSort="true"
              filterType="int"
              table="retirementAnalysis"
              :filterOptions="headerFilterOptions[item.columnName]"
              :getFilterOptions="cheoxList"
              :width="item.displayWidth"
              :searchReset="searchReset"
              @confirmFilter="confirmFilter"
              @cheoxList="cheoxList"
            />
            <template v-if="item.displayName.includes('销量')">
              <el-tooltip class="item" effect="dark" placement="top">
                <span class="el-icon-question"></span>
                <div slot="content">包含京东入仓销量</div>
              </el-tooltip>
            </template>
          </template>
          <template slot-scope="scope">
            <template v-if="item.displayName === '图片'">
              <el-button v-if="scope.row.imgList.length" size="mini" type="text" @click="viewImg(scope.row)">查看</el-button>
            </template>
            <template v-else>
              {{ scope.row[item.columnName] | cellValFormat }}
            </template>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>
    <custom-table v-model="tableVisible" :tableDataSet="tableDataSet" v-if="tableVisible" @closeAddForm="closeAddForm" @confirm="confirm"></custom-table>
  </content-panel>
</template>

<script>
import imgShow from "@/views/components/imgShow";
import customPropsMixin from "./customProps.mixin";
import pagePathMixin from '@/utils/page-path-mixin';
import tableMixin from '@/utils/tableMixin';

export default {
  components: { imgShow },
  mixins: [customPropsMixin, pagePathMixin, tableMixin],
  name: "retirementAnalysis",
  data() {
    return {
      headerFilterOptions: {},
      varietyList: [],
      queryCriteria: [],
      loading: false,
      loadingExport: false,
      imgUrl: "",
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      searchForm: {
        filterData: {},
        categoryQuery: "",
        productCodeQuery: "",
        productNameQuery: "",
        modelNameQuery: "",
        upDateStart: "",
        upDateEnd: "",
      },
      // 图片弹窗
      imgFormVisible: false,
      imgList: [],
      tableReload: true,
      searchReset: false,
      searchFormData: [],
      pageTure: false,
    };
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.searchReset = true;
      this.$store.commit("headerFilters/delHeaderFilter", "retirementAnalysis");
      this.queryCriteria = [
        {
          orderBy: "",
          paramName: "productCodeQuery", //产品编码
          paramValue: this.searchForm.productCodeQuery,
          type: "like",
        },
        {
          orderBy: "",
          paramName: "productNameQuery", //产品名称
          paramValue: this.searchForm.productNameQuery,
          type: "like",
        },
        {
          orderBy: "",
          paramName: "modelNameQuery", //产品型号
          paramValue: this.searchForm.modelNameQuery,
          type: "like",
        },
        {
          orderBy: "",
          paramName: "categoryQuery", //品类
          paramValue: this.searchForm.categoryQuery,
          type: "like",
        },
        {
          orderBy: "",
          paramName: "upDateQuery", //上市时间
          paramValue: this.searchForm.upDateStart ? this.searchForm.upDateStart + "," + this.searchForm.upDateEnd : "",
          type: "between",
        },
      ];
      this.pageTure = false;
      this.init();
    },
    init(item) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.paramValue);
      let param = {
        filterData: {
          queryCriteria: filter,
          reportName: this.reportName,
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      if (this.pageTure) {
        param.filterData = item.filterData;
      }
      this.searchFormData = param;
      this.$q.common.reportSearch({ data: JSON.stringify(param) }).then((res) => {
        this.tableData = res.data;
        if (null != this.tableData.records) {
          this.loading = false;
        }
        if (res.code == 200) {
          this.loading = false;
          this.pageTure = false;
          this.searchReset = false;
        }
      });
    },
    cheoxList(name, type) {
      this.columnList = [];
      this.columnList = JSON.parse(JSON.stringify(this.searchFormData.filterData.queryCriteria));
      let obj = {
        type: "",
        paramValue: "",
        orderBy: "",
        paramName: name,
      };
      this.columnList.forEach((v, index) => {
        if (v && v.paramName == name) {
          delete this.columnList[index];
        }
      });
      this.columnList.push(obj);
      let data = {
        colParam: this.columnList,
        reportName: this.reportName,
      };
      data.colParam = this.columnList.filter((n) => n);
      return this.$q.common.reportGetIndexInfo({ data: data }).then((res) => {
        if (type == "string") {
          this.$set(this.headerFilterOptions, name, res.data.string);
        } else {
          this.$set(this.headerFilterOptions, name, res.data.numerical);
        }
      });
    },
    confirmFilter(filterParam) {
      let that = this;
      let tableName = "retirementAnalysis";
      this.common.confirmFilter(that, filterParam, tableName);
    },
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.pageTure = true;
      this.init(this.searchFormData);
    },
    handleSizeChange(val) {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = val;
      this.pageTure = true;
      this.onSearch(this.searchFormData);
    },
    // 查看图片
    viewImg(row) {
      this.imgFormVisible = true;
      this.imgList = [];
      const list = row.imgList;
      for (const item of list) {
        this.imgList.push(item.path);
      }
    },
    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        taskDTO: {
          appCode: "ec-pc-api",
          paramMap: this.searchFormData.filterData,
          reportName: this.reportName,
        },
        columnDTOs: null,
      };
      let tmp = JSON.parse(JSON.stringify(this.columnData));

      params.columnDTOs = tmp.map((item) => {
        return {
          columnName: item.displayName,
          fieldName: item.columnName,
          fieldType: item.fieldType,
          columnFormat: item.columnFormat,
        };
      });
      params.columnDTOs = params.columnDTOs.filter((v) => v.columnName !== "图片");
      this.$q.common
        .customExportExcel({ data: params })
        .then((res) => {
          loading.close();
          this.$message({
            type: "success",
            message: "导出成功,请在导出列表中查看",
          });
        })
        .catch((err) => {});
    },
    reset() {
      this.searchForm = {
        categoryQuery: "",
        productCodeQuery: "",
        productNameQuery: "",
        modelNameQuery: "",
        upDateStart: "",
        upDateEnd: "",
      };
      this.tableData.pageNum = 1;
      this.onSearch();
      this.searchReset = true;
      this.$store.commit("headerFilters/delHeaderFilter", "retirementAnalysis");
    },
    dataFormat(data) {
      let list = data.records;
      for (let item of list) {
        item.clearance ? (item.clearance = "是") : (item.clearance = "否");
      }
      data.records = list;
      return data;
    },
    queryDelistAnalyseCategory() {
      this.$q.productLifeCycle.queryDelistAnalyseCategory().then((res) => {
        this.varietyList = res.data;
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
  mounted() {
    this.queryDelistAnalyseCategory();
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
.footerBox
  text-align right

.search-box
  >>> .el-select, >>> .el-input
    width 240px !important

>>> .date-range .single-date
  width 110px !important
</style>
